import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-rateio-energia-edit',
  templateUrl: './rateio-energia-edit.component.html',
  styleUrls: ['./rateio-energia-edit.component.css'],
  standalone: false
})
export class RateioEnergiaEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/rateio-energia`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Rateio de Energia', link: '/rateio-energia' }, { label: 'Edição Rateio de Energia' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'rateio-energia',
  };

  fields: PoPageDynamicEditField[] = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('rateio-energia').subscribe(data => {
        this.fields = data;
    });
  }
}
